import audioService from '../services/AudioService';

// `=== false` rather than truthiness: settings that have not loaded yet must not silence the screen.
const isOff = flag => flag === false;

export const scanPackSettingsFrom = getState =>
  getState().user?.bothSettings?.data?.data?.scanpack_setting;

export const showsSuccessImage = settings => !isOff(settings?.show_success_image);
export const showsFailImage = settings => !isOff(settings?.show_fail_image);

export const playSuccessFeedback = async getState => {
  if (isOff(scanPackSettingsFrom(getState)?.play_success_sound)) return;
  await audioService.playSuccessSound();
};

export const playErrorFeedback = async getState => {
  if (isOff(scanPackSettingsFrom(getState)?.play_fail_sound)) return;
  await audioService.playErrorSound();
};

export const playNotReadyFeedback = async getState => {
  if (isOff(scanPackSettingsFrom(getState)?.play_fail_sound)) return;
  await audioService.playNotReadySound();
};
